import StreamPage from './stream';
import DataService from './services/DataService';

const state = {
  	name: 'stream',
  	url: '/stream/:account_uuid/:contact_uuid/:event_id?{env}&{ignore_account_branding}',
  	component: StreamPage,
    resolve: [
        {
            token: 'data',
            deps: ['$transition$'],
            resolveFn: (trans) => DataService.get(trans.params())
        }
    ]
};

export default state;